export var EGeoLevelSortDirection;
(function (EGeoLevelSortDirection) {
    EGeoLevelSortDirection["desc"] = "desc";
    EGeoLevelSortDirection["asc"] = "asc";
})(EGeoLevelSortDirection || (EGeoLevelSortDirection = {}));
